module.exports = __webpack_public_path__ + "static/media/successOnboard.e35d5be4.svg";